<template>
  <div class="apartment-plans">
    <div class="apartment-plans__content">
      <SectionHeader>Floorplan</SectionHeader>

      <HMTViewer
        :items="getFloorplanPhotos"
        containerClassName="apartment-plans__plans-wrapper"
        itemClassName="apartment-plans__plan"
        imgClassName="apartment-plans__plan-image"
      >
        <FontAwesomeIcon icon="eye" size="3x" />
      </HMTViewer>

      <div
        v-if="getFloorplanFiles.length > 0" 
        class="apartment-plans__more-informations"
      >
        <span class="apartment-plans__more-informations-label">More information</span>

        <div class="apartment-plans__plan-files-list">
          <a
            v-for="(plan, index) in getFloorplanFiles"
            :key="plan"
            :href="plan" 
            target="_blank"
            class="apartment-plans__plan-file"
          >
            <span class="apartment-plans__plan-file-extension">PDF</span>
            <span class="apartment-plans__plan-file-name">Document {{ index + 1 }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import HMTViewer from '@/shared/components/VViewer';
  import SectionHeader from '../../components/SectionHeader';

  export default {
    name: 'Floorplan',
    components: {
      SectionHeader,
      HMTViewer
    },
    computed: {
      ...mapGetters('tour', ['getFloorplanPhotos', 'getFloorplanFiles'])
    }
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .apartment-plans {
    $self: &;
    
    background-color: var(--primary-section-color);

    &__content {
      @include layoutContent();
      @include layoutHPadding();
      @include layoutVPadding();
    }

    &__plan {
      position: relative;
      margin: 0 0 50px 0;
      cursor: pointer;

      &:hover {
        &:before {
          opacity: .4;
        }
        svg {
          opacity: 1;
        }
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        background-color: var(--primary-color);
        opacity: 0;
        pointer-events: none;
        transition: opacity .2s ease-out;
      }

      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 2;
        margin-top: -24px;
        margin-left: -27px;
        opacity: 0;
        color: var(--floorplan-icon-color);
        pointer-events: none;
        transition: opacity .2s ease-out;
      }
    }

    &__plan-image {
      max-width: 100%;
    }

    &__more-informations {
      background-color: var(--secondary-section-color);
      display: flex;
      padding: 20px;
      flex-direction: column;
    }

    &__more-informations-label {
      font-size: 20px;
      font-weight: 600;
      margin: 20px;
    }

    &__plan-file {
      text-decoration: none;
      margin: 20px;
      font-size: 16px;
      display: flex;
      &:hover,
      &:focus {
        #{$self}__plan-file-name {
          text-decoration: underline;
          color: var(--primary-color);
        }
      }
    }

    &__plan-file-extension {
      background-color: var(--floorplan-icon-color);
      padding: 5px 7px 4px;
      margin-right: 10px;
      color: #fff;
      font-size: 14px;
      line-height: 1;
      display: inline-block;
    }

    &__plan-file-name {
      color: var(--floorplan-file-name-color);
      display: inline-block;
      margin-top: auto;
      margin-bottom: auto;
    }

    @include mdScreen() {
      &__plan-files-list {
        margin: auto -40px auto -40px;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
      }
      &__more-informations {
        margin-top: 40px;
        padding: 40px;
        flex-direction: row;
      }

      &__plan-file {
        margin: 20px;
      }
      &__more-informations-label {
        margin: auto 60px auto;
      }

      &__plans-wrapper {
        display: flex;
        flex-wrap: wrap;
      }

      &__plans-wrapper {
        margin: -25px;
        overflow: hidden;
      }

      &__plan {
        margin: 0;
        padding: 25px;
        width: 50%;
        box-sizing: border-box;
      }
    }

    @include lgScreen() {
      &__more-informations {
        margin-top: 60px;
      }
    }
  }
</style>
